var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container whiteCont mt-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-6 mt-5 pt-5" }, [
              _c(
                "h1",
                {
                  staticClass: "mb-5 center",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.result,
                    callback: function($$v) {
                      _vm.result = $$v
                    },
                    expression: "result"
                  }
                },
                [_vm._v(_vm._s(_vm.result))]
              ),
              _vm._v(" "),
              _vm.status
                ? _c(
                    "div",
                    { staticClass: "mt-5 center" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary btn-lg",
                          attrs: { to: "/login" }
                        },
                        [_vm._v("Accedi")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0a1213a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a1213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/index.vue
// module id = null
// module chunks = 